module.exports = __webpack_public_path__ + "img/3-2.dbc0c3d7.png";